import { Soportes } from "../../services/soportes.js";
import moment from "moment";
import store from "../index.js";

export default {
  namespaced: true,
state:{ 
    soportes: [],
//  numero de pagina y total de registros
    number: 1,
    size: 10,
    page: 1,
    total: 0,
    visible: 7,
// numero de registro por pagina
    rowsPerPage: 20,

//errores de api
    errored: false,
    error: false,

    //  filter fechas inicio y fin
    fechaDesde: moment()
      .subtract(1, "months")
      .format("YYYY-MM-DD"),
    fechaHasta: moment().format("YYYY-MM-DD"),
    usuario: "",
    email:"",
    visto: false,
    nombre2: "",
    consulta: "",
    estado: "",
    abierto: false,
    archivo:"",
    cargando: false,
    notificaciones:"",
    sinVinculoSoporte: false,
    mensajeVinculo: "",
    errorMensaje: "",
    mensajeExito: "",
    search: "",
    estadosFiltro: [],
    categoriaFiltro: [],

},

mutations :{

  actualizarSoporte(state, soporteActualizado) {
    // El state guarda los tickets con la key `Id` (mayúscula) por el mapeo legacy.
    // Buscar el índice basado en Id o id (compatible con ambos formatos).
    const targetId = soporteActualizado.id ?? soporteActualizado.Id;
    const indice = state.soportes.findIndex(
      soporte => (soporte.Id ?? soporte.id) === targetId
    );

    if (indice !== -1) {
      const actualizado = {
        ...state.soportes[indice],
        ...soporteActualizado,
        Id: targetId,
      };
      const nuevosSoportes = [
        ...state.soportes.slice(0, indice),
        actualizado,
        ...state.soportes.slice(indice + 1),
      ];
      state.soportes = nuevosSoportes;
    }
  },
  

  actualizarArchivo(state, nuevoArchivo) {
    state.archivo = nuevoArchivo;
  },


    // mutations soporte
    setSoportes(state, soportes) {
      state.soportes = soportes;
    },
    setId(state, value) {
        state.id = value;
    },
    setSize(state, value) {
      state.size = value;
    },

    setNombre(state, value) {
        state.nombre = value;
    },

    setEmail(state, value) {
      state.email = value;
    },

    setVisto(state, value) {
      state.visto = value;
    },
    setArchivo(state, archivo) {
      state.archivo = archivo;
    },

    setNombre2(state, value) {
        state.nombre2 = value;
    },

    setConsulta(state, value) {
        state.consulta = value;
    }, 

    setRespuestas(state, value){
      state.respuestas = value;
    },

    setEstado(state, value) {
        state.estado = value;
    },

    setAbierto(state, value) {
      state.abierto = value;
    },

    setPaginate(state, value) {
      state.page = value;
    },

    setCargando(state, value) {
      state.cargando = value;
    },
    
    setrowsPerPage(state, value) {
        state.rowsPerPage = value;
    },
    
    setFechaInicio(state, value) {
      state.fechaDesde = value;
    },

    setFechaFin(state, value) {
      state.fechaHasta = value;
    },
    setErrord(state, value) {
        state.errored = value;
    },

    setTotal(state, value) {
      state.total = value;
    },

    setNotificaciones(state, value){
      state.notificaciones = value;
    },

    setSinVinculoSoporte(state, value) {
      state.sinVinculoSoporte = value;
    },

    setMensajeVinculo(state, value) {
      state.mensajeVinculo = value;
    },

    setErrorMensaje(state, value) {
      state.errorMensaje = value;
    },

    setMensajeExito(state, value) {
      state.mensajeExito = value;
    },

    setSearch(state, value) {
      state.search = value;
    },

    setEstadosFiltro(state, value) {
      state.estadosFiltro = value;
    },

    setCategoriaFiltro(state, value) {
      state.categoriaFiltro = value;
    }

    },

    actions: {

      //Traer Soportes
      async getSoportes({ commit, state, rootGetters }) {
        commit("setCargando", true);
        commit("setErrord", false);
        commit("setErrorMensaje", "");
        commit("setSinVinculoSoporte", false);
        commit("setMensajeVinculo", "");

        // El external_id es el id de la tabla clientes (cliente seleccionado en
        // la sesión). El back lo valida y fuerza el alcance hacia api_go_soporte.
        const clienteId = rootGetters.getCurrentClientId;
        const actorEmail = store.state.email;

        if (!clienteId) {
          commit("setErrorMensaje", "No hay un cliente seleccionado. Volvé a iniciar sesión.");
          commit("setSoportes", []);
          commit("setNotificaciones", 0);
          commit("setPaginate", 1);
          commit("setTotal", 0);
          commit("setCargando", false);
          return;
        }

        // page/per_page + filtros (mismas claves que api_go_soporte espera).
        const params = { page: state.page, per_page: state.rowsPerPage };
        if (state.search && state.search.trim()) {
          params.search = state.search.trim();
        }
        if (state.estadosFiltro && state.estadosFiltro.length > 0) {
          params.estado = state.estadosFiltro.join(",");
        }
        // categoria como CSV (igual que estado). Incluye el centinela "__sin__"
        // si el usuario eligió "Sin categoría" (tickets con categoria NULL/vacía).
        if (state.categoriaFiltro && state.categoriaFiltro.length > 0) {
          params.categoria = state.categoriaFiltro.join(",");
        }

        await Soportes.getSoportes(clienteId, actorEmail, params).then((response) => {
          // Si el cliente no tiene tickets, vaciamos el store.
          if (response?.data?.data == null || response?.data?.data.length === 0) {
            commit("setSoportes", []);
            commit("setNotificaciones", 0);
            commit("setPaginate", 1);
            commit("setTotal", 0);
            commit("setCargando", false);
          } else {
            // Mapear el Ticket de api_go_soporte a la estructura que usa la vista.
            const mappedSoportes = response.data.data.map(t => ({
              Id: t.id,
              ClientName: t.client_name,
              ClientColor: (t.client_color && t.client_color.startsWith('#') ? t.client_color : (t.client_color ? '#' + t.client_color : '#6366f1')),
              Consulta: t.consulta,
              Asunto: t.asunto,
              Estado: t.estado,
              Visto: t.visto,
              Abierta: t.abierta,
              Archivo: "",
              Respuestas: t.response_count || 0,
              Categoria: t.categoria,
              Prioridad: t.prioridad,
              Usuario: t.creator_name || t.creator_email || "Sin usuario",
              Email: t.creator_email,
              Fecha: t.created_at,
              LastResponseAt: t.last_response_at,
            }));

            commit("setSoportes", mappedSoportes);
            commit("setNotificaciones", 0);
            commit("setPaginate", response.data.page);
            commit("setTotal", response.data.total_pages);
          }
        })
        .catch((error) => {
          if (error.response) {
            var data = error.response.status;
            if (data == 403) {
              const msg = error.response.data?.error
                || "No tiene permiso para acceder al sistema de soporte. Contactá al administrador.";
              commit("setErrorMensaje", msg);
              commit("setSoportes", []);
              commit("setNotificaciones", 0);
              commit("setPaginate", 1);
              commit("setTotal", 0);
            } else if (data === 401) {
              commit("setErrorMensaje", "Sesión expirada. Volvé a iniciar sesión.");
              commit("setSoportes", []);
            } else if (data === 404) {
              // El external_id (cliente) no está dado de alta en el proyecto de
              // soporte. No es un error del sistema: aviso amable + lista vacía.
              commit("setSinVinculoSoporte", true);
              commit("setMensajeVinculo",
                "Este cliente todavía no está dado de alta en el sistema de soporte. Contactá al administrador.");
              commit("setSoportes", []);
              commit("setNotificaciones", 0);
              commit("setPaginate", 1);
              commit("setTotal", 0);
            } else {
              const msg = error.response.data?.error || "Error al obtener los tickets de soporte.";
              commit("setErrorMensaje", msg);
            }
          } else {
            commit("setErrord", true);
            commit("setErrorMensaje", "No se pudo conectar con el sistema de soporte.");
          }
        })
        .finally(() => commit("setCargando", false));
      },


      // Traer Archivo
      async getSoporteFile({ commit }, archivo) {
        // console.log("archivo: recibido", archivo)
        try {
          // Verifica si state.archivo está definido y no es vacío
          if (archivo) {
            // Llama al servicio para obtener el archivo de soporte
            const response = await Soportes.getSoporteFile(archivo);
      
            if (response.data == null) {
              commit("setArchivo", []);
            } else {
              commit("setArchivo", response.data);
            }
      
            // console.log("Archivo traído con Éxito!", response);
            return response;
          } else {
            // No hay archivo, no se realiza ninguna llamada
            // console.log("No hay archivo para obtener.");
            return null; // O cualquier otro valor que desees devolver
          }
        } catch (error) {
          // console.error("Error obteniendo archivo de soporte Store:", error);
          if (error.response) {
            const data = error.response.status;
            if (data == 403) {
              // Realizar el manejo del token de refresco aquí
              // console.log("Token de refresco requerido.");
            }
          } else {
            commit("setErrord", true);
          }
          throw error;
        }
      },
      

      //Crear Soporte
        async createSoporte({ rootGetters }, payload) {
          try {
            const clienteId = rootGetters.getCurrentClientId;
            const actorEmail = payload.email || store.state.email || rootGetters.getCurrentClientEmail;
            if (!clienteId) {
              const err = new Error(
                "No hay un cliente seleccionado. No se puede crear el ticket."
              );
              err.userMessage = err.message;
              throw err;
            }

            const hasAttachments = payload.attachments && payload.attachments.length > 0;

            if (hasAttachments) {
              // Multipart one-shot: el back fija el external_id; acá solo van los
              // campos del ticket + los archivos.
              const fd = new FormData();
              fd.append("asunto", payload.asunto || "Soporte");
              fd.append("consulta", payload.consulta);
              fd.append("prioridad", String(payload.prioridad || 1));
              if (payload.categoria) fd.append("categoria", payload.categoria);
              if (actorEmail) fd.append("email", actorEmail);
              for (const f of payload.attachments) {
                fd.append("file", f);
              }
              return await Soportes.createSoporteMultipart(clienteId, actorEmail, fd);
            }

            // Sin adjuntos: JSON.
            const jsonPayload = {
              asunto: payload.asunto || "Soporte",
              consulta: payload.consulta,
              prioridad: payload.prioridad || 1,
            };
            if (payload.categoria) jsonPayload.categoria = payload.categoria;
            if (actorEmail) jsonPayload.email = actorEmail;

            return await Soportes.createSoporteJson(clienteId, actorEmail, jsonPayload);
          } catch (error) {
            const backendMsg = error.response?.data?.error;
            if (backendMsg) {
              error.userMessage = backendMsg;
            }
            throw error;
          }
        },

        //Crear Soporte Respuesta
        async createSoporteRespuesta({ rootGetters }, respuestaData) {
          try {
            const clienteId = rootGetters.getCurrentClientId;
            const actorEmail = store.state.email;
            // respuestaData puede ser FormData (con archivo) o un objeto JSON.
            // Solo necesitamos el id del ticket (soportesId) y el texto/archivos;
            // el external_id lo fija el back. Cualquier campo legacy se ignora.
            const isFormData = typeof FormData !== "undefined" && respuestaData instanceof FormData;
            const ticketId = isFormData
              ? respuestaData.get("soportesId")
              : respuestaData.soportesId;

            if (!ticketId) {
              throw new Error("Falta el id del ticket (soportesId).");
            }

            if (isFormData) {
              // Reconstruir un FormData limpio: soporte espera 'respuesta' + 'file'.
              const fd = new FormData();
              fd.append("respuesta", respuestaData.get("respuesta") || "");
              for (const f of respuestaData.getAll("file")) {
                if (f) fd.append("file", f);
              }
              return await Soportes.createRespuestaMultipart(clienteId, actorEmail, ticketId, fd);
            }

            return await Soportes.createRespuestaJson(clienteId, actorEmail, ticketId, {
              respuesta: respuestaData.respuesta,
            });
          } catch (error) {
            const backendMsg = error.response?.data?.error;
            if (backendMsg) error.userMessage = backendMsg;
            throw error;
          }
        },

        // Marcar ticket como leído
        async markSoporteRead({ rootGetters }, { ticketId }) {
          try {
            const clienteId = rootGetters.getCurrentClientId;
            const actorEmail = store.state.email;
            return await Soportes.markSoporteRead(clienteId, actorEmail, ticketId);
          } catch (error) {
            const backendMsg = error.response?.data?.error;
            if (backendMsg) error.userMessage = backendMsg;
            throw error;
          }
        },

        // Obtener detalle completo de un ticket (ticket + responses + attachments)
        async getSoporteDetail({ rootGetters }, { ticketId, includeThumbs }) {
          try {
            const clienteId = rootGetters.getCurrentClientId;
            const actorEmail = store.state.email;
            const opts = includeThumbs ? { include_thumbs: 1 } : undefined;
            return await Soportes.getSoporteDetail(clienteId, actorEmail, ticketId, opts);
          } catch (error) {
            const backendMsg = error.response?.data?.error;
            if (backendMsg) error.userMessage = backendMsg;
            throw error;
          }
        },

        // Listar adjuntos de un ticket
        async listSoporteAttachments({ rootGetters }, { ticketId }) {
          try {
            const clienteId = rootGetters.getCurrentClientId;
            const actorEmail = store.state.email;
            return (await Soportes.listAttachments(clienteId, actorEmail, ticketId)) || [];
          } catch (error) {
            const backendMsg = error.response?.data?.error;
            if (backendMsg) error.userMessage = backendMsg;
            throw error;
          }
        },

        



        // Token efímero para abrir el WebSocket directo a soporte (tiempo real).
        async getRealtimeToken({ rootGetters }) {
          const clienteId = rootGetters.getCurrentClientId;
          const actorEmail = store.state.email;
          return await Soportes.realtimeToken(clienteId, actorEmail);
        },

        //Editar Soporte (estado / abierto)
        async editarSoporte({ commit, rootGetters }, { nuevosDatos }) {
          try {
            const clienteId = rootGetters.getCurrentClientId;
            const actorEmail = store.state.email;
            const ticketId = nuevosDatos.id;
            const payload = {
              estado: nuevosDatos.estado,
              abierta: nuevosDatos.abierto,
            };
            const response = await Soportes.putSoporte(clienteId, actorEmail, ticketId, payload);
            commit('actualizarSoporte', { ...nuevosDatos, id: ticketId });
            return response;
          } catch (error) {
            const backendMsg = error.response?.data?.error;
            if (backendMsg) error.userMessage = backendMsg;
            throw error;
          }
        }


      },


      

getters: {
    fechaDesde: (state) => state.fechaDesde,
    fechaHasta: (state) => state.fechaHasta,
    pages: (state) => state.page,
    nombre: (state) => state.nombre,
    email: (state) => state.email,
    visto: (state) => state.visto,
    consulta: (state) => state.consulta,
    respuestas:(state) => state.respuestas,
    estado: (state) => state.estado,
    abierto: (state) => state.abierto,
    archivo: (state) => state.archivo,
    notificaciones:(state) => state.notificaciones,
    soportes:(state) => state.soportes
    
        },
      modules: {},
}